import { connectionUp, handleMessage } from '.';
import { RegisterApp, SynergyMessage } from '../types';
const retyDelay = 5000;
let connectionTimer: NodeJS.Timeout | undefined;
let socket: WebSocket;
let ready = false;
const messageQueue: string[] = [];

export const connect = () => {
  try {
    if (socket && !socket.CLOSED) {
      return;
    }
    console.log('Attempting to connect');
    socket = new WebSocket('ws://localhost:9011/agent');
    socket.onopen = onReady;
    socket.onclose = onClose;
    socket.onmessage = onMessage;
    socket.onerror = onError;
  } catch (error) {
    console.log(error);
    setReconnectTimeOut();
  }
};

const setReconnectTimeOut = () => {
  if (!connectionTimer) {
    connectionTimer = setTimeout(() => {
      connectionTimer = undefined;
      connect();
    }, retyDelay);
  }
};

const onReady = () => {
  console.log('Socket ready');
  ready = true;
  const registerApp: RegisterApp = {
    subject: 'REGISTER_APP',
    title: document.title,
    url: document.URL,
  };
  socket.send(JSON.stringify(registerApp));
  connectionUp();
  //send pending messages
  let message: string | undefined;
  while ((message = messageQueue.pop())) {
    socket.send(message);
  }
};

const onClose = (ev: CloseEvent) => {
  console.log(`Connection closed, reason: ${ev.reason}`);
  ready = false;
  setReconnectTimeOut();
};

/* eslint-disable  @typescript-eslint/no-explicit-any */
const onMessage = (ev: MessageEvent<any>) => {
  console.log(`Message received: ${ev.data}`);
  try {
    const message = JSON.parse(ev.data) as SynergyMessage;
    if (message) {
      handleMessage(message);
    }
  } catch (error) {
    console.log(error);
  }
};

const onError = () => {
  console.log('Socket error');
  if (socket.CLOSED) {
    ready = false;
    setReconnectTimeOut();
  }
};

export const sendMessage = (synergyMessage: SynergyMessage) => {
  console.log('sending message');
  const stringMessage = JSON.stringify(synergyMessage);
  if (ready) {
    socket.send(stringMessage);
  } else {
    messageQueue.push(stringMessage);
    if (messageQueue.length > 5) {
      messageQueue.pop();
    }
  }
};
